<template>
  <video
    :src="getSourceOnce(attributes.value)"
    v-bind="attrs"
    controlsList="nodownload"
    playsinline
    muted>
  </video>
</template>

<script>
export default {
  props: ['attributes'],
  computed: {
    attrs () {
      const {poster, autoplay, loop, controls} = this.attributes
      return {
        poster: poster ? this.getPosterSource(poster) : null,
        autoplay: !autoplay || autoplay === 'true',
        loop: !loop || loop === 'true',
        controls: !controls || controls === 'true'
      }
    },
    hasDesktopSource () {
      const {hasdesktop} = this.attributes
      return !hasdesktop || hasdesktop !== 'false'
    }
  },
  methods: {
    getPosterSource (value) {
      let path = null
      if (value) {
        const [name, ext] = value.split('.')
        path = name + (!global.isMobile && this.hasDesktopSource ? '-desktop.' : '.') + ext
      }
      return path ? require(`videos/${path}`) : null
    },
    getSourceOnce (value) {
      const [name, ext] = value.split('.')
      const path = name + (!global.isMobile && this.hasDesktopSource ? '-desktop.' : '.') + ext
      return require(`videos/${path}`)
    }
  }
}
</script>
